import { useQuery } from '@tanstack/react-query';
import type { AuditLogResponse } from '@orion/contracts';
import { getPage } from '../../../lib/api-client.js';

export interface AuditLogFilters {
  page: number;
  actorId?: string;
  action?: string;
  entityType?: string;
  ip?: string;
  dateFrom?: string;
}

const PAGE_SIZE = 25;

function toQueryString(filters: AuditLogFilters): string {
  const params = new URLSearchParams({ page: String(filters.page), pageSize: String(PAGE_SIZE) });
  if (filters.actorId) params.set('actorId', filters.actorId);
  if (filters.action) params.set('action', filters.action);
  if (filters.entityType) params.set('entityType', filters.entityType);
  if (filters.ip) params.set('ip', filters.ip);
  if (filters.dateFrom) params.set('dateFrom', filters.dateFrom);
  return params.toString();
}

export function useAuditLogsQuery(filters: AuditLogFilters) {
  return useQuery({
    queryKey: ['audit-logs', filters],
    queryFn: () => getPage<AuditLogResponse[]>(`/admin/audit-logs?${toQueryString(filters)}`),
  });
}

export function auditExportUrl(filters: Omit<AuditLogFilters, 'page'>): string {
  const params = new URLSearchParams();
  if (filters.actorId) params.set('actorId', filters.actorId);
  if (filters.action) params.set('action', filters.action);
  if (filters.entityType) params.set('entityType', filters.entityType);
  if (filters.ip) params.set('ip', filters.ip);
  if (filters.dateFrom) params.set('dateFrom', filters.dateFrom);
  const qs = params.toString();
  return `/api/v1/admin/audit-logs/export${qs ? `?${qs}` : ''}`;
}
